import { createSelector, createSlice } from '@reduxjs/toolkit';

import type { AdUnit } from '@wix/ambassador-adsense-v1-adsense-adunit/types';
import { type RootState } from '@app/settings-store';
import { type FetchStatus } from '@app/store/settings/types';
import { fetchAdUnitByCompId, fetchAdUnitsList } from './fetch-actions';

type AdsenseAdunitsState = {
  adUnits?: AdUnit[];
  connectedAdUnit?: AdUnit;
  status: FetchStatus;
  connectedAdUnitStatus: FetchStatus;
};

const adsenseAdunitsState: AdsenseAdunitsState = {
  adUnits: [],
  status: 'idle',
  connectedAdUnitStatus: 'idle',
};

export const adsenseAdunitsSlice = createSlice({
  name: 'adsenseAdunits',
  initialState: adsenseAdunitsState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchAdUnitsList.fulfilled, (state, action) => {
        state.adUnits = action.payload.adUnits || [];
        state.status = 'success';
      })
      .addCase(fetchAdUnitsList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAdUnitsList.rejected, (state) => {
        state.status = 'error';
      })
      .addCase(fetchAdUnitByCompId.fulfilled, (state, action) => {
        state.connectedAdUnit = action.payload.adUnit;
        state.connectedAdUnitStatus = 'success';
      })
      .addCase(fetchAdUnitByCompId.pending, (state) => {
        state.connectedAdUnitStatus = 'loading';
      })
      .addCase(fetchAdUnitByCompId.rejected, (state) => {
        state.connectedAdUnitStatus = 'error';
      });
  },
});

export const selectAdsenseAdunitState = (state: RootState) =>
  state.adsenseAdunits;

export const selectAdUnitsData = createSelector(
  [selectAdsenseAdunitState],
  ({ adUnits, connectedAdUnit }) => {
    const all = adUnits || [];
    if (!connectedAdUnit) {
      return all;
    }
    const others = all.filter(
      (u) => u.reportingDimensionId !== connectedAdUnit.reportingDimensionId,
    );
    return [connectedAdUnit, ...others];
  },
);
export const selectConnectedAdUnit = createSelector(
  [selectAdsenseAdunitState],
  (state) => state.connectedAdUnit,
);
export const selectAdUnitsStatus = createSelector(
  [selectAdsenseAdunitState],
  (state) => state.status,
);
export const selectConnectedAdUnitStatus = createSelector(
  [selectAdsenseAdunitState],
  (state) => state.connectedAdUnitStatus,
);

export const {} = adsenseAdunitsSlice.actions;

export default adsenseAdunitsSlice.reducer;
export * from './fetch-actions';
